export default {
  audienceFlow(state: any) {
    return state.audienceFlow;
  },
  audienceId(state: any) {
    return state.audienceId;
  },
  audienceCopy(state: any) {
    return state.audienceCopy;
  },
  audienceTips(state: any, root, rootState, rootGetters) {
    return state.tips[rootGetters["user/user"]._id];
  },
};
